import styles from "./index.module.css";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";

const characteristics = [
  "Мінімальна сума розстрочки: 2 грн",
  "Максимальна сума розстрочки: 400 000 грн",
  "Реальна річна процентна ставка: 0,000001%",
  "Доступний строк, платежів: 3 - 25",
  "Порядок погашення: щомісячні платежі рівними частинами",
  "Перший платіж у момент оформлення покупки",
];

export default function InstallmentInfo() {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.card}>
        <h1>
          Покупка частинами
          <br className={styles.titleBreak} />
          monobank | Universal Bank
        </h1>

        <p className={styles.label}>Надавач послуг:</p>
        <p>
          АТ «УНІВЕРСАЛ БАНК» ліцензія НБУ №92 від 20.01.1994, номер у
          держреєстрі банків № 226.
        </p>

        <p className={styles.label}>Характеристики продукту:</p>
        <ul className={styles.list}>
          {characteristics.map((item) => (
            <li key={item}>{item}</li>
          ))}
          <li>
            Інформація про істотні характеристики продукту та попередження
            розміщені на сайті продукту{" "}
            <a
              href="https://chast.monobank.ua"
              target="_blank"
              rel="noreferrer"
            >
              chast.monobank.ua
            </a>
          </li>
        </ul>
      </div>
      <Footer />
    </div>
  );
}
